/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_Misa_Inv_SeriesInputs */

const vi_einvoice_settings_misa_inv_series = /** @type {(inputs: Einvoice_Settings_Misa_Inv_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ký hiệu hoá đơn`)
};

/**

* @param {Einvoice_Settings_Misa_Inv_SeriesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_misa_inv_series = /** @type {((inputs?: Einvoice_Settings_Misa_Inv_SeriesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_Misa_Inv_SeriesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_misa_inv_series(inputs)
});